<template>
  <footer class="login-footer">
    <div class="login-footer__branding">
      <div class="login-footer__logo">
        <img :src="integrityLogo" alt="Integrity Connect" />
      </div>
    </div>
    <div class="login-footer__text">
      <p>{{ companyText }}</p>
    </div>
  </footer>
</template>

<script setup>
defineProps({
  integrityLogo: {
    type: String,
    required: true
  },
  companyText: {
    type: String,
    default: 'Integrity Connect is a trading division of Integrity Communications Group'
  }
})
</script>

<style scoped>
.login-footer {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 3rem;
  background: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  color: white;
}

.login-footer__branding {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.login-footer__logo {
  max-height: 70px;
}

.login-footer__logo img {
  height: 100%;
  max-height: 70px;
  width: auto;
  display: block;
}

.login-footer__text {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.9);
  text-align: right;
}

.login-footer__text p {
  margin: 0;
}

@media (max-width: 768px) {
  .login-footer {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1.5rem;
    text-align: center;
  }

  .login-footer__text {
    text-align: center;
  }
}
</style>
